import Layout from "@/components/Layout";
import HeroSection from "@/components/HeroSection";
import CategoriesSection from "@/components/CategoriesSection";
import ProductGrid from "@/components/ProductGrid";
import RelayPointsSection from "@/components/RelayPointsSection";
import Footer from "@/components/Footer";
import { AdvertisementBanner } from "@/components/AdvertisementBanner";
import { AdvertisementDisplay } from "@/components/AdvertisementDisplay";
import { SEO } from "@/components/SEO";

const Index = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-background">
        <SEO
          title="Nazandoo - Marketplace e-commerce Kinshasa | Points relais sécurisés RDC"
          description="Nazandoo, la marketplace #1 à Kinshasa. Achetez et vendez en ligne en toute sécurité. +100 points relais, paiement CB/Mobile Money, livraison rapide RDC."
          keywords="marketplace Kinshasa, e-commerce RDC, achat en ligne Congo, vendre en ligne Kinshasa, points relais Congo, shopping en ligne Kinshasa, paiement mobile money Congo"
        />
        <AdvertisementBanner />
      <main className="relative">
        <HeroSection />
        <CategoriesSection />
        
        {/* Publicité milieu de page */}
        <div className="container mx-auto px-4 my-8">
          <AdvertisementDisplay position="middle" />
        </div>
        
          <ProductGrid />
          <RelayPointsSection />
          
          {/* Publicité bas de page */}
          <div className="container mx-auto px-4 my-8">
            <AdvertisementDisplay position="bottom" />
          </div>
        </main>
        
        {/* Barre latérale publicité (position fixe) */}
        <div className="hidden xl:block fixed right-4 top-1/2 -translate-y-1/2 w-64 z-40">
          <AdvertisementDisplay position="sidebar" />
        </div>
        
        <Footer />
      </div>
    </Layout>
  );
};

export default Index;
